function getRotatedImage(state) {
    return {
        width: state.imageSize.width,
        height: state.imageSize.height,
        angle: state.transforms.rotate,
    };
}

export { getRotatedImage };
